import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TelemetryData } from 'src/app/model/telemetry-data';

@Component({
  selector: 'app-telemetry-dashboard',
  templateUrl: './telemetry-dashboard.component.html',
  styleUrls: ['./telemetry-dashboard.component.css']
})
export class TelemetryDashboardComponent implements OnInit, OnDestroy {
  carId: string = '';
  currentTelemetry: TelemetryData | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Obtém carId da rota
    this.route.params.subscribe(params => {
      this.carId = params['carId'] || params['id'];
    });

    // Ou use um carId fixo para testes
    if (!this.carId) {
      this.carId = 'CAR001'; // ID de teste
    }
  }

  ngOnDestroy(): void {
    // Cleanup será feito pelos componentes filhos
  }

  onDataReceived(data: TelemetryData): void {
    this.currentTelemetry = data;
    //console.log('[Dashboard] Telemetry data received:', data);
  }
}
